import styled from 'styled-components';
import Text from '@signplatform-ui/text';

// eslint-disable-next-line import/prefer-default-export
export const StyledText = styled(Text)`
  margin-bottom: 8px;
`;
